(() => {
  'use strict';
  const make = (tag, className, text) => {
    const node = document.createElement(tag);
    if (className) node.className = className;
    if (text !== undefined) node.textContent = text;
    return node;
  };
  async function mount(root) {
    if (root.dataset.mounted) return;
    root.dataset.mounted = 'true';
    const story = root.querySelector('[data-editorial-slides]');
    const track = story.querySelector('[data-slide-track]');
    const slides = [...story.querySelectorAll('[data-slide]')];
    const selectors = [...story.querySelectorAll('[data-slide-select]')];
    let selected = 0;
    const motion = matchMedia('(prefers-reduced-motion: reduce)');
    function activate(index) {
      selected = Math.max(0, Math.min(slides.length - 1, index));
      slides.forEach((slide, position) => {
        slide.inert = position !== selected;
        slide.setAttribute('aria-hidden', String(position !== selected));
      });
      selectors.forEach((button, position) => button.setAttribute('aria-pressed', String(position === selected)));
    }
    function show(index) {
      const target = Math.max(0, Math.min(slides.length - 1, index));
      track.scrollTo({left: target * track.clientWidth, behavior: motion.matches ? 'instant' : 'smooth'});
    }
    selectors.forEach((button, index) => button.addEventListener('click', () => show(index)));
    let frame;
    track.addEventListener('scroll', () => {
      cancelAnimationFrame(frame);
      frame = requestAnimationFrame(() => activate(Math.round(track.scrollLeft / track.clientWidth)));
    }, {passive:true});
    story.addEventListener('keydown', event => {
      if (event.target !== track && !selectors.includes(event.target)) return;
      if (!['ArrowLeft','ArrowRight','Home','End'].includes(event.key)) return;
      event.preventDefault();
      show(event.key === 'Home' ? 0 : event.key === 'End' ? slides.length - 1 : selected + (event.key === 'ArrowRight' ? 1 : -1));
    });
    const storySize = new ResizeObserver(() => track.scrollTo({left:selected * track.clientWidth, behavior:'instant'}));
    storySize.observe(track);
    document.addEventListener('shopify:section:unload', event => {
      if (event.target.contains(root)) {storySize.disconnect();cancelAnimationFrame(frame);}
    });
    activate(0);
    const labels = JSON.parse(root.querySelector('[data-home-labels]').textContent);
    const prefix = root.dataset.root.replace(/\/$/, '');
    const collection = `${prefix}/collections/original-footwear`;
    const money = new Intl.NumberFormat(root.dataset.locale === 'ar' ? 'ar-EG' : 'en-EG', { style: 'currency', currency: 'EGP', maximumFractionDigits: 2 });
    const cheapest = product => product.variants.reduce((best, current) => Number(current.price) < Number(best.price) ? current : best);
    const productUrl = product => `${prefix}/products/${encodeURIComponent(product.handle)}?variant=${cheapest(product).id}`;
    const imageUrl = (url, width) => `${url}${url.includes('?') ? '&' : '?'}width=${width}`;
    const reducedMotion = matchMedia('(prefers-reduced-motion: reduce)').matches;
    const rtl = getComputedStyle(root).direction === 'rtl';
    function price(product, target) {
      const variant = cheapest(product);
      target.replaceChildren(make('span', '', money.format(variant.price)));
      if (Number(variant.compare) > Number(variant.price)) target.append(make('s', '', money.format(variant.compare)));
    }
    function card(product) {
      const item = make('li', 'db-edit-card');
      const link = make('a', 'db-edit-card-photo'); link.href = productUrl(product);
      const photo = make('img'); photo.src = imageUrl(product.images[0], 640); photo.alt = product.title;
      photo.width = 640; photo.height = 640; photo.loading = 'lazy'; photo.decoding = 'async';
      link.append(photo);
      const badges = make('db-card-badges');
      badges.dataset.brand = product.brand;
      badges.dataset.sale = String(Number(cheapest(product).compare) > Number(cheapest(product).price));
      badges.dataset.saleLabel = labels.sale;
      link.append(badges);

      const title = make('h3'); const name = make('a', '', product.title); name.href = link.href; title.append(name);
      const cost = make('p', 'db-edit-card-price'); price(product, cost);
      const sizes = [...new Set(product.variants.map(v => v.size).filter(Boolean))].sort((a, b) => a.localeCompare(b, undefined, { numeric: true }));
      item.append(link, make('p', 'db-edit-kicker', product.brand), title, cost);
      if (sizes.length) item.append(make('p', 'db-edit-card-sizes', `${labels.sizes}: ${sizes.join(' · ')}`));
      return item;
    }
    function rail(name, products) {
      const track = root.querySelector(`[data-home-rail="${name}"]`);
      track.replaceChildren(...products.map(card));
      const controls = root.querySelector(`[data-rail-controls="${name}"]`);
      const previous = controls.querySelector('[data-rail-prev]');
      const next = controls.querySelector('[data-rail-next]');
      function update() {
        const maximum = track.scrollWidth - track.clientWidth;
        const position = Math.abs(track.scrollLeft);
        controls.hidden = maximum < 4;
        previous.disabled = position < 4; next.disabled = position >= maximum - 4;
      }
      function move(direction) {
        const distance = track.firstElementChild.getBoundingClientRect().width + parseFloat(getComputedStyle(track).columnGap);
        track.scrollBy({ left: direction * distance * (rtl ? -1 : 1), behavior: reducedMotion ? 'instant' : 'smooth' });
      }
      previous.addEventListener('click', () => move(-1)); next.addEventListener('click', () => move(1));
      track.addEventListener('scroll', update, { passive: true });
      track.addEventListener('keydown', event => {
        if (event.target !== track || !['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
        event.preventDefault(); move((event.key === 'ArrowRight' ? 1 : -1) * (rtl ? -1 : 1));
      });

      const observer = new ResizeObserver(update); observer.observe(track);
      document.addEventListener('shopify:section:unload', event => { if (event.target.contains(root)) observer.disconnect(); });
      update();
    }
    try {
      const response = await fetch(root.dataset.indexUrl, { signal: AbortSignal.timeout(20000) });
      if (!response.ok) throw new Error('Catalogue unavailable');
      const data = await response.json();
      const products = data.products.filter(product => product.variants?.length && product.images?.length);
      if (!products.length) {
        if (root.querySelector('.db-edit-feature')) root.querySelector('.db-edit-feature').hidden = true;
        root.querySelector('[data-home-rail="featured"]').replaceChildren();
        root.querySelector('[data-home-sizes]').replaceChildren();
        root.querySelector('db-brand-carousel[data-kind="footwear"]').dispatchEvent(new CustomEvent('brands:change', { detail: [] }));
        return;
      }
      const featured = products.slice(0, 12);
      rail('featured', featured);
      const brandNames = [...new Set(products.map(product => product.brand).filter(Boolean))];
      const preferred = ['Adidas', 'Nike', 'PUMA', 'NEW BALANCE', 'Skechers', 'Reebok', 'Converse', 'asics'];
      const brands = [...new Set([...preferred.map(name => brandNames.find(brand => brand.toLowerCase() === name.toLowerCase())).filter(Boolean), ...brandNames.sort((a, b) => a.localeCompare(b))])];
      root.querySelector('db-brand-carousel[data-kind="footwear"]').dispatchEvent(new CustomEvent('brands:change', { detail: brands }));
      const sizes = [...new Set(products.flatMap(product => product.variants.map(variant => {
        const range = variant.size.trim().match(/^(\d+)\s*[/／]\s*(\d+)$/);
        if (range && Math.abs(Number(range[1]) - Number(range[2])) === 1) return Number(range[1]) % 2 === 0 ? Number(range[1]) : Number(range[2]);
        const match = variant.size.match(/^(\d+)(?:(?:[.,]\d+)|(?:\s+\d+\s*[/⁄]\s*\d+)|[½⅓⅔¼¾])?$/);
        return match ? Number(match[1]) : null;
      })))].filter(size => size >= 36 && size <= 47).sort((a, b) => a - b);
      root.querySelector('[data-home-sizes]').replaceChildren(...sizes.map(size => {
        const link = make('a'); link.href = `${collection}?size=${size}`; link.append(make('span', '', 'EU'), document.createTextNode(` ${size}`)); return link;
      }));
      root.dataset.loaded = 'true';
    } catch (_) {
      root.dataset.loadFailed = 'true';
    }
  }
  document.querySelectorAll('[data-footwear-home]').forEach(mount);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-footwear-home]').forEach(mount));
})();
